import { ChainId } from '@pancakeswap/chains'
import { masterChefV3Addresses } from '@pancakeswap/farms'
import { ADDRESS_ZERO, DEPLOYER_ADDRESSES } from '@pancakeswap/v3-sdk'
import { V3_QUOTER_ADDRESSES } from '@pancakeswap/smart-router/evm'
import NineInchConfig from '@9inch/config'

export default {
  masterChef: {
    [ChainId.PULSE]: '0x444775Ae2C82560337c86f6D62909a63381De4fd',
  },
  masterChefV3: masterChefV3Addresses,
  masterChefV1: {
  },
  multiCall: {
    [ChainId.PULSE]: NineInchConfig[ChainId.PULSE].Multicall3 as `0x${string}`,
  },
  orderBook: {
    [ChainId.PULSE]: ADDRESS_ZERO,
  },
  stableSwapNativeHelper: {
  },
  nftPositionManager: {
    [ChainId.PULSE]: NineInchConfig[ChainId.PULSE].NonfungiblePositionManager as `0x${string}`,
  },
  v3PoolDeployer: DEPLOYER_ADDRESSES,
  v3Migrator: {
    [ChainId.PULSE]: ADDRESS_ZERO,
  },
  quoter: V3_QUOTER_ADDRESSES,
  v3Airdrop: {
  },
  PointsFarming: {
    [ChainId.PULSE]: ADDRESS_ZERO as `0x${string}`,
  },
  LootBox: {
    [ChainId.PULSE]: '0x441f707B895f97A52dFc55d1CF3a4a998DdCD734' as `0x${string}`,
  },
} as const satisfies Record<string, Record<number, `0x${string}`>>